import React, { createContext, useContext, useState } from 'react';
import Modal from '../components/common/Modal';
import Button from '../components/common/Button';
import SafeIcon from '../common/SafeIcon';

const ErrorContext = createContext();

export const ErrorProvider = ({ children }) => {
  const [error, setError] = useState(null);

  return (
    <ErrorContext.Provider value={{ showError: setError }}>
      {children}
      {error && (
        <Modal title="Notice" onClose={() => setError(null)}>
          <div className="flex items-start space-x-3 text-amber-600 mb-6">
            <SafeIcon icon="AlertCircle" className="w-6 h-6 shrink-0 mt-0.5" />
            <p className="text-sm whitespace-pre-wrap leading-relaxed">{error}</p>
          </div>
          <div className="flex justify-end">
            <Button onClick={() => setError(null)}>OK</Button>
          </div>
        </Modal>
      )}
    </ErrorContext.Provider>
  );
};

export const useError = () => useContext(ErrorContext);